import * as THREE from "three";
import Car from "../res/models/car.glb";
import Stage from "../res/models/stage.glb";
import Cubemap from "../res/textures/cubemap.png";
import NumberPlateAlbedo from "../res/textures/car/numberplate.jpg";
import CarAlbedo from "../res/textures/car/car.jpg";
import CarMetallicRough from "../res/textures/car/car_metallic_rough.jpg";
import FloorAlbedo from "../res/textures/floor.png";
import TyreAO from "../res/textures/car/tyres_ao.jpg";
import TyreNormal from "../res/textures/car/tyres_normal.jpg";
import Snowflake1 from "../res/textures/snowflake1.jpg";
import Snowflake2 from "../res/textures/snowflake2.jpg";

const assets = {
  files: {
    car: { type: "model", path: Car },
    stage: { type: "model", path: Stage },
    refl: {
      type: "cubemap",
      path: Cubemap
    },
    numberPlateAlbedo: {
      type: "texture",
      path: NumberPlateAlbedo
    },
    carAlbedo: {
      type: "texture",
      path: CarAlbedo
    },
    carMetallicRough: {
      type: "texture",
      path: CarMetallicRough
    },
    floorAlbedo: {
      type: "texture",
      path: FloorAlbedo
    },
    tyreAO: {
      type: "texture",
      path: TyreAO
    },
    tyreNormal: {
      type: "texture",
      path: TyreNormal
    },
    snowflake1: {
      type: "texture",
      path: Snowflake1
    },
    snowflake2: {
      type: "texture",
      path: Snowflake2
    }
  },

  /* Most materials are auto-imported, but some need a bit of extra attention */

  initMaterials: (assets, data) => {
    const materials = {};
    const ambIntensity = 2.1;

    assets.carAlbedo.encoding = THREE.sRGBEncoding;

    materials.Body = new THREE.MeshPhysicalMaterial({
      color: data.color,
      metalness: data.metalness,
      roughness: 0.55,
      clearcoat: 1.0,
      clearcoatRoughness: 0.06,
      envMapIntensity: ambIntensity
    });
    materials.Car = new THREE.MeshStandardMaterial({
      map: assets.carAlbedo,
      metalness: 1.0,
      roughnessMap: assets.carMetallicRough,
      metalnessMap: assets.carMetallicRough,
      envMapIntensity: ambIntensity
    });
    materials.Glass = new THREE.MeshPhysicalMaterial({
      color: 0xffffff,
      transparent: true,
      depthWrite: false,
      roughness: 0.06,
      transmission: 0.9,
      envMapIntensity: ambIntensity
    });
    materials.TailLights = new THREE.MeshStandardMaterial({
      color: 0xff0000,
      emissive: 0xff030d,
      emissiveIntensity: 2.0,
      metalness: 1.0,
      roughness: 0.1
    });
    materials.NumberPlate = new THREE.MeshStandardMaterial({
      map: assets.numberPlateAlbedo,
      roughness: 0.8
    });
    materials.Floor = new THREE.MeshBasicMaterial({
      color: 0x999999,
      map: assets.floorAlbedo
    });
    materials.Tyres = new THREE.MeshStandardMaterial({
      color: 0x0b0b0b,
      roughness: 0.4,
      normalMap: assets.tyreNormal,
      aoMap: assets.tyreAO,
      envMapIntensity: 0.5
    });
    materials.ShadowCaster = new THREE.MeshBasicMaterial({
      color: 0x000000,
      transparent: true,
      blending: THREE.AdditiveBlending,
      depthWrite: false
    });
    materials.ShadowReceiver = new THREE.ShadowMaterial({
      opacity: 0.9
    });

    return materials;
  }
};

export default assets;
